import React from 'react';
import MenuChangePasswordButton from './MenuChangePasswordButton';
import MenuLogoutButton from './MenuLogoutButton';

const MenuAccountActions = ({ isOpen, isMobile }) => (
    <div className={isMobile ? 'menu-account-footer-mobile' : 'menu-account-footer'}>
        <MenuChangePasswordButton isOpen={isOpen} isMobile={isMobile} />
        <MenuLogoutButton isOpen={isOpen} isMobile={isMobile} />
    </div>
);

export default MenuAccountActions;
